import React from 'react';
import { useSelector } from 'react-redux';
import { GlobeNetworkIcon } from 'evergreen-ui';
import { datasourceStatusSoftReleaseModeSelector } from 'Features/App/Dictionaries/dictionariesSlice';
import { timeZoneSelector } from 'Features/App/appSlice';
import { UTCtoTimeZone } from 'Utils/UTCConverter';
import StatusIcon from './StatusIcon';
import { DatasourceIdProps } from '../utils';
import { initialStatusData, StatusDataType } from './utils';

export function SoftReleaseStatus({ datasourceId }:DatasourceIdProps) {
  const selectedZone = useSelector(timeZoneSelector);
  const status = useSelector(datasourceStatusSoftReleaseModeSelector(datasourceId));

  const { text, intent, time }: StatusDataType = React.useMemo(() => {
    const { isActual, dateTimeUpdate } = status || {};

    if (isActual === true) {
      return {
        time: UTCtoTimeZone(dateTimeUpdate, selectedZone.selectedUserTimeZone),
        text: 'Актуальный',
        intent: 'success',
      };
    }
    if (isActual === false) {
      return {
        time: UTCtoTimeZone(dateTimeUpdate, selectedZone.selectedUserTimeZone),
        text: 'Устарел',
        intent: 'danger',
      };
    }

    return initialStatusData;
  }, [selectedZone.selectedUserTimeZone, status]);

  return (
    <StatusIcon
      time={time}
      statusInfo={`Релиз: ${text}`}
      intent={intent}
      icon={GlobeNetworkIcon}
    />
  );
}
export default SoftReleaseStatus;
